<script setup>
  import { computed, nextTick } from 'vue'
  import ActiveItemFollowUp from '@/components/Event/ActiveItemFollowUp.vue'
  import WishlistAddButton from '@/components/Wishlist/AddButton.vue'

  const emit = defineEmits(['toggleWishlist'])

  const props = defineProps({
    event: Object
  })

  const toggleWishlist = async () => {
    await nextTick()
    emit('toggleWishlist')
  }

  const timeString = computed(() => {
    const event = props.event
    if (!event || !event.dates || !event.dates[0]) return ''

    if (event.dates[0].startDate === event.dates[0].endDate) {
      return `${event.dates[0].weekday.slice(0, 3)}, ${event.dates[0].startTime} - ${event.dates[0].endTime} Uhr`
    }
    return `${event.dates[0].weekday.slice(0, 3)}, ${event.dates[0].startTime} - ${event.dates[0].endDay.slice(0, 3)} ${event.dates[0].endTime} Uhr`
  })

  const day = computed(() => {
    return props.event.dates[0].day
  })

  const month = computed(() => {
    return props.event.dates[0].month.slice(0, 3)
  })
</script>

<template>
<div class="max-w-screen-2xl mx-auto">
  <div class="event-teaser-details grid grid-cols-12 ~py-12/16 border-b border-border text-body">
    <div
      class="node-event-teaser-big-date ~py-12/16 col-span-1 flex flex-col w-full h-full items-center justify-center"
    >
      <p
        class="mb-0 ~text-3xl/5xl"
      >
        {{ day }}
      </p>
      <p
        class="my-0 uppercase"
      >
        {{ month }}
      </p>
    </div>

    <div class="event-teaser-main-date w-full col-span-5 ~pl-12/16">
    <div v-if="event.seminar" class="event-teaser-seminar">
      <p class="!text-primary mb-3 font-bold">{{ event.seminar }}</p>
    </div>
    <p class="mb-1">
      <strong>
        {{ event.headline }}
      </strong>
    </p>
    <p v-if="event.dates && event.dates[0]" class="flex flex-row items-center mb-2">
      <AppIcon name="EventDate" class="mr-2"></AppIcon>
      <span v-if="event.dates[0].startDate === event.dates[0].endDate">
        {{ event.dates[0].startDate }}
      </span>
      <span v-else>
        {{ event.dates[0].startDate }} - {{ event.dates[0].endDate }}
      </span>
    </p>
    <p v-if="event.dates && event.dates[0]" class="flex flex-row items-center mb-2">
      <AppIcon name="Clock" class="mr-2"></AppIcon>
        <span>{{ timeString }}</span>
    </p>
    <p v-if="event.location" class="flex flex-row items-center mb-2">
      <AppIcon name="EventRoute" class="mr-2"></AppIcon>
      <span>{{ event.location }}</span>
    </p>
    <p v-if="event.speaker" class="flex flex-row items-center mb-2">
      <AppIcon name="Avatar" class="mr-2"></AppIcon>
      <span>
        {{ 'mit ' }}
        <a class="underline underline-offset-4" :href="event.speaker.url">
          {{ event.speaker.name }}
        </a>
      </span>
    </p>
  </div>

  <div v-if="event.followUp" class="event-teaser-follow-up col-span-3 w-full ~pl-12/16 border-l border-border">
    <ActiveItemFollowUp :followUp="event.followUp" />
  </div>

  <div class="event-teaser-actions flex flex-col items-start gap-4 col-span-3">
    <WishlistAddButton
      @click="toggleWishlist"
      :node-id="event.id"
    />
    <a
      :href="event.url"
      class="w-full max-w-52 h-10 flex justify-center items-center bg-primary text-white text-sm rounded-full"
      :aria-label="`Zur Terminanmeldung für ${event.headline}`"
    >
      <AppIcon name="ArrowLink"></AppIcon>
      {{ 'Zur Anmeldung' }}
    </a>
  </div>
  </div>
</div>
</template>

<style lang="scss" scoped>
.event-teaser-details {
  .node-event-teaser-big-date p {
    @apply ~text-xl/2xl first:~text-3xl/5xl ;
  }
}

:deep(svg) {
  @apply w-5 h-5;
}
.event-teaser-actions :deep(svg) {
  @apply mr-2 w-4 h-4;
}
.event-teaser-actions a :deep(svg path) {
  fill: #fff !important;
}
</style>
